import { atomWithDefault } from "jotai/utils";
import { loadCompanies } from "./client.service";

export const companyAtom = atomWithDefault(async (get) => {
  return await loadCompanies();
});
